import React, { useContext, useEffect } from 'react';
import { LanguageContext } from "../../context/LanguageContext";

const ReportOverview = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("ReportOverview", "product_lib/product_report_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.ReportOverview || { Main: {} };

  return (
    <div className="report">
      <div className="container">
        <div className="section-header">
          <h2>{LANGUAGE.Main.Title}</h2>
          <p>{LANGUAGE.Main.Subtitle}</p>
        </div>

        <div className="row report-container">
          {/* KPI 統計圖 */}
          <div className="col-lg-3 col-md-6 col-sm-6 report-item web-des">
            <div className="report-wrap">
              <figure>
                <img src={LANGUAGE.Main.Img_lib_5} alt="KPI" />
                <a href={LANGUAGE.Main.Img_lib_5} className="link-preview" data-lightbox="report">
                  <i className="fa fa-eye"></i>
                </a>
                <a className="report-title">
                  {LANGUAGE.Main.KPIChart}
                </a>
              </figure>
            </div>
          </div>

          {/* 報酬率折線圖 */}
          <div className="col-lg-3 col-md-6 col-sm-6 report-item web-des">
            <div className="report-wrap">
              <figure>
                <img src={LANGUAGE.Main.Img_lib_6} alt="Returns" />
                <a href={LANGUAGE.Main.Img_lib_6} className="link-preview" data-lightbox="report">
                  <i className="fa fa-eye"></i>
                </a>
                <a className="report-title">
                  {LANGUAGE.Main.ReturnChart}
                </a>
              </figure>
            </div>
          </div>

          {/* 損益分布圖 */}
          <div className="col-lg-3 col-md-6 col-sm-6 report-item web-des">
            <div className="report-wrap">
              <figure>
                <img src={LANGUAGE.Main.Img_lib_7} alt="PnL" />
                <a href={LANGUAGE.Main.Img_lib_7} className="link-preview" data-lightbox="report">
                  <i className="fa fa-eye"></i>
                </a>
                <a className="report-title">
                  {LANGUAGE.Main.PnLChart}
                </a>
              </figure>
            </div>
          </div>

          {/* 買賣訊號圖 */}
          <div className="col-lg-3 col-md-6 col-sm-6 report-item web-dev">
            <div className="report-wrap">
              <figure>
                <img src={LANGUAGE.Main.Img_lib_8} alt="Signals" />
                <a href={LANGUAGE.Main.Img_lib_8} className="link-preview" data-lightbox="report">
                  <i className="fa fa-eye"></i>
                </a>
                <a className="report-title">
                  {LANGUAGE.Main.SignalChart}
                </a>
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportOverview;
